import Loadable from '../components/Loadable';
import { lazy } from 'react';
import { RouteObject } from 'react-router';

const ListingList = Loadable(lazy(() => import('pages/listings/List')));
const ListingCreate = Loadable(lazy(() => import('pages/listings/Create')));
const ListingEdit = Loadable(lazy(() => import('pages/listings/Edit')));
const TemplateList = Loadable(lazy(() => import('pages/templates/List')));
const TemplateCreate = Loadable(lazy(() => import('pages/templates/Create')));
const TemplateEdit = Loadable(lazy(() => import('pages/templates/Edit')));

const ThriftShopRoutes: RouteObject = {
    path: 'shop',
    children: [
        {
            path: 'listings',
            element: <ListingList />,
        },
        {
            path: 'listings/new',
            element: <ListingCreate />,
        },
        {
            path: 'listings/:id',
            element: <ListingEdit />,
        },
        {
            path: 'templates',
            element: <TemplateList />,
        },
        {
            path: 'templates/new',
            element: <TemplateCreate />,
        },
        {
            path: 'templates/:id',
            element: <TemplateEdit />,
        },
    ],
};

export default ThriftShopRoutes;
